/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取旗舰店公告,最新咨询,新闻聚焦内容
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  id: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/shop/information-info/${id}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
